import fetchJsonp from 'fetch-jsonp';
import loadScript from '../util/loadscript';
export default class Risk {
  static init = false;
  static umidToken = null;
  static umUrl = '//g.alicdn.com/security/umscript/3.3.30/um.js';
  static uabUrl = '//uaction.alicdn.com/js/uab.js';
  /**
   * 初始化UA_Opt
   */
  static initUAOpt() {
    if (!window.UA_Opt) {
      window.UA_Opt = {
        FormId: '1',
        SendMethod: 9,
        MaxKSLog: 20,
        LogVal: 'ua',
        Sync: true,
        MaxMCLog: 10,
        MaxMPLog: 5,
        MPInterval: 50,
        MaxFocusLog: 5,
        isSendError: 1,
        Token: `${new Date().getTime()}:${Math.random()}`,
        Flag: 1670350,
      };
    }
  }
  /**
   * 加载风控脚本
   */
  static async loadAssets() {
    await Promise.all([loadScript(Risk.umUrl), loadScript(Risk.uabUrl)]);
  }
  /**
   * 获取风控参数
   */
  static getParams() {}
  static async firstGet() {
    Risk.initUAOpt();
    await Risk.loadAssets();
    return fetchJsonp('//promotion.aliyun.com/risk/getToken.htm', {
      jsonpCallback: 'cback',
    })
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          Risk.umidToken = res.data;
          Risk.initUmid();
          Risk.init = true;
        }
      })
      .catch(() => {
        Risk.init = true;
      });
  }
  static async getToken() {
    if (Risk.init) {
      return {
        umidToken: Risk.umidToken,
        collina: await Risk.getUA(),
      };
    } else {
      await Risk.firstGet();
      return {
        umidToken: Risk.umidToken,
        collina: await Risk.getUA(),
      };
    }
  }
  static async getUA() {
    if (!window.UA_Opt) {
      return null;
    }
    return new Promise(resolve => {
      let tmp_ua = window[window.UA_Opt.LogVal];
      if (!tmp_ua) {
        setTimeout(() => {
          tmp_ua = window[window.UA_Opt.LogVal];
          window.UA_Opt.Token = `${new Date().getTime()}:${Math.random()}`;
          window.UA_Opt.reload && window.UA_Opt.reload();
          resolve(tmp_ua);
        }, 500);
      } else {
        resolve(tmp_ua);
      }
    });
  }
  static initUmid() {
    const umidToken = Risk.umidToken;
    const $container = $('<div id="#_umfp_risk"></div>');
    $('body').append($container);
    $container.append('<img src="//ynuf.alipay.com/service/clear.png?xt=' + umidToken + '&xa=act-aliyun-com" />');
    // 仅仅初始化执行一次
    if (window.um) {
      window.um.init({
        timeout: 3000,
        timestamp: new Date().getTime(),
        token: umidToken,
        serviceUrl: '//ynuf.alipay.com/service/um.json',
        appName: 'act-aliyun-com',
        containers: {
          flash: $container[0],
          dcp: $container[0],
        },
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/risk.js